import React from 'react';
import { Divider } from '@material-ui/core';
import { Breadcrumb } from 'components';
import { Link } from 'react-router-dom';

import './Setting.scss';

const SettingMenu = () => {
  return (
    <div id="SettingMenu" className="pb-24 px-8 bg-default">
      <div className="breadcrumb">
        <Breadcrumb routeSegments={[{ name: '設定メニュー' }]} />
      </div>

      <h2>設定メニュー</h2>
      <Divider style={{ backgroundColor: "#777", marginBottom: 20 }} className="topDivider" />

      <Link to="/setting/createAccount">
        <h3 style={{ color: '#022db4' }}>アカウント発行</h3>
      </Link>
      ユーザーID・パスワードを発行し、アクセスを許可します。
      <Divider style={{ backgroundColor: "#777", marginTop: 20, marginBottom: 20 }} className="topDivider" />

    </div>
  );
};

export default SettingMenu;
